import React, {Component} from 'react';
import { connect } from 'react-redux';

class Finish extends Component {
  render() {
    return (
      <div className="row signup-box">
        <div className="col-md-8 col-md-offset-2">
          <div className="sing-box">
            <div className="email-box">
              <h1 className="text-center">What happens next?</h1>
              <p className="text-center text-finish">
                Your business page has been sent to Rifird’s support team for review. <br/>
                Approvals typically take 2 days or less. <br/><br/>
                Once your business is approved, we’ll send you an email to let you claim it.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep
  })
)(Finish);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/finish.js
 **/